import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: RouteComponent,
  staticData: {
    icon: 'LayoutGrid',
    title: 'Overview',
  },
});

function RouteComponent() {
  return <div>Hello "/(authenticated)/dashboard"!</div>;
}
